var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScattershot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 60,
    viewBox: "0 0 120 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M26.972 46.023L25.3295 47.016H23.6855L20.5445 46.146L20.09 44.5275V43.3245L21.077 39.636L24.188 34.2315L24.344 33.15L23.033 30.8325L19.8905 32.061L18.8255 32.1015L13.586 33.8625L2.738 29.7765L1.8125 28.254L4.01 26.385L3.6395 24.651L3.722 23.0955L2.357 21.1035L17.3135 17.7195H24.0545L26.0195 18.5925L28.094 17.064H36.9365L39.938 18.5925L55.604 18.2655L56.2595 18.8655L66.5765 18.0465L108.526 18.1035L105.538 14.5395H106.724L110.081 17.4465L110.9 18.21L115.976 20.394L116.227 24.543L114.749 24.432L114.013 26.3445L113.035 27.5235L113.371 29.25L113.249 31.548L111.875 33.1515L109.972 34.7505L108.033 34.8045V35.6265L109.151 36.4125L103.258 39.171L103.585 40.536L101.838 41.5725L75.8165 39.8355L74.4515 39.024L73.406 37.5525L71.3525 36.789L69.899 37.014L68.507 36.1755L66.992 36.339L65.945 35.748L64.3715 35.787L63.1295 35.0385L62.2625 35.2545L54.1775 33.4935L46.481 33.432L42.494 33.1215L42.878 33.699L49.283 37.554C49.283 37.554 50.4155 38.223 50.372 38.694C50.3285 39.165 49.652 39.6705 49.124 39.5355C48.596 39.4005 38.0675 35.808 38.0675 35.808L36.5315 34.785L35.9555 33.819H30.986V35.949L28.6115 37.914L27.629 39.7275L27.752 41.5575L26.729 43.686L26.975 46.02L26.972 46.023Z",
    fill: "#FAFAFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9644 18.105L78.9629 20.1225L64.2254 21.105L52.2164 20.826L36.9299 20.625L27.8894 20.5065L26.0144 18.5955C26.0144 18.5955 26.9429 20.6355 26.7779 20.625C26.6129 20.6145 24.6254 22.3065 24.6254 22.3065H21.6464C21.6464 22.3065 20.9099 21.255 19.3949 21.3375C17.8799 21.42 16.8974 22.524 16.6934 23.343L15.0974 24.681V26.865L16.6529 28.257H19.3964C19.3964 28.257 20.6654 28.0695 21.4019 27.4875H28.8074",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.072 23.6476L34.413 24.5686L63.1305 25.3396L75.033 25.6591L80.4915 22.3051H83.058L83.8755 23.0071",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5674 20.8245L62.5334 25.23L57.2939 27.486",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0173 28.5062L42.0093 28.6367L45.2298 30.3287",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7087 28.0067L56.8022 30.4937L78.2537 29.5922",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1308 20.559C86.8623 20.559 88.2658 20.1957 88.2658 19.7475C88.2658 19.2994 86.8623 18.936 85.1308 18.936C83.3994 18.936 81.9958 19.2994 81.9958 19.7475C81.9958 20.1957 83.3994 20.559 85.1308 20.559Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6904 20.5591C100.422 20.5591 101.825 20.1958 101.825 19.7476C101.825 19.2994 100.422 18.9361 98.6904 18.9361C96.959 18.9361 95.5554 19.2994 95.5554 19.7476C95.5554 20.1958 96.959 20.5591 98.6904 20.5591Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2673 19.7476H95.5558",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M101.826 19.7475H103.744L104.55 19.194H110.131L110.841 20.559L111.936 21.105H114.141",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4402 22.9334L99.2687 21.9224H105.056L106.038 22.6874H109.094L111.168 24.7064",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9265 31.9395C66.9265 31.9395 70.774 33.495 71.9215 34.3965C73.0675 35.2965 73.8865 36.771 75.6055 37.017C77.3245 37.263 85.1305 37.5555 85.1305 37.5555",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2674 31.614C88.2674 31.614 86.4554 32.922 86.0879 34.437C85.7189 35.952 86.4149 37.554 86.4149 37.554",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3854 23.2606C90.3854 23.2606 88.4819 25.0771 88.2674 26.3191C88.0529 27.5596 88.7489 29.2501 88.7489 29.2501",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8132 23.2066L103.199 25.6591H114.14",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0691 27.9166L112.915 28.0066",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6072 36.4141L106.679 36.7291L107.58 37.5541",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2751 31.6141L95.1751 32.7991L99.0241 34.1506L110.528 34.2796",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9791 27.6495H13.2566V25.659L13.8941 25.3905L14.2391 24.6795",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0989 24.6796H10.2224",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2573 25.659H11.3328V27.6495H13.2573",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0164 18.5941L28.5379 19.2076L29.3059 18.5941H33.8494L36.9319 20.6236L31.8964 24.5686V27.1051",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6238 20.3535L40.9318 18.5925H41.9548L43.0198 19.473L49.2418 19.6575L50.0203 19.248C50.0203 19.248 53.6638 19.002 53.7043 19.125C53.7448 19.248 54.1963 19.473 54.1963 19.473",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6697 18.5941L52.7087 20.5996",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6314 28.9095H27.6264L25.5384 30.834L17.4099 30.4935H21.3219L22.6314 28.9095Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4451 29.9985V32.718L27.6271 34.3545V36.279L29.6341 37.068",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9314 34.9276L37.8614 33.5341L41.9954 35.3791H43.2239L50.3699 39.0256",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6275 36.2791L24.9665 38.2846C24.9665 38.2846 23.861 37.9246 23.492 39.0256C23.123 40.1266 24.0245 40.6591 24.0245 40.6591L23.861 43.2796L23.033 46.8346",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9846 33.684V35.952L28.6101 37.917L27.5451 39.882L27.7491 41.5605L26.7261 43.689L26.9721 46.023L25.7031 46.965L24.2286 47.166L20.5446 46.146L19.8891 43.812L20.4621 42.42L21.0756 39.636L24.1866 34.2315L24.3906 32.676L23.4906 31.1205H22.5081L19.8876 32.0625L18.8226 32.103L13.5831 33.864L2.73507 29.778L1.80957 27.6825L3.55407 26.7165C3.55407 26.7165 4.20957 26.5185 4.20957 25.7505C4.20957 24.9825 3.63657 24.654 3.63657 24.654L3.71907 23.0985L2.16357 21.42L2.73657 20.478L17.3106 17.721H24.0516L26.0166 18.594L28.0911 17.0655H36.9336L39.9351 18.594L55.6011 18.267L56.2566 18.867L66.5736 18.048L110.897 18.2115L115.973 20.3955L116.224 24.5445L114.554 24.5985C114.554 24.5985 114.5 25.854 114.008 26.3445C113.516 26.835 112.972 27.1635 112.916 28.0905C112.861 29.0175 113.516 28.4175 113.408 30.219C113.299 32.0205 113.026 32.184 112.699 32.457C112.372 32.73 109.97 34.749 109.97 34.749L108.005 34.803L107.951 35.5665L109.426 36.603L103.258 39.168L103.585 40.533L101.839 41.5695L76.0746 39.987L74.0556 38.7855L73.8921 38.022L73.3806 37.524C73.3806 37.524 72.9711 37.5855 72.4191 37.4625C71.8671 37.3395 71.3541 36.7875 71.3541 36.7875C71.3541 36.7875 70.8216 37.218 69.9006 37.0125C68.9796 36.807 68.5086 36.174 68.5086 36.174C68.5086 36.174 67.9971 36.543 66.9936 36.3375C65.9901 36.132 65.8671 35.58 65.8671 35.58C65.8671 35.58 65.2536 36.0105 64.3731 35.784C63.4926 35.5575 63.2466 35.0055 63.2466 35.0055L62.2641 35.2515L54.1791 33.4905L46.4826 33.429L45.5406 32.979L42.2661 32.856C42.2661 32.856 42.7161 33.327 42.8796 33.6945C43.0431 34.0635 49.6761 37.7685 49.6761 37.7685C49.6761 37.7685 50.7021 38.166 50.3316 39.1605C50.0451 39.9285 48.7431 39.4395 48.2436 39.2835C45.5721 38.445 37.5996 35.64 37.5996 35.64L36.0231 34.371L35.9211 33.5115C35.9211 33.5115 34.6731 33.7575 34.0986 33.7365C33.5241 33.7155 30.9876 33.6795 30.9876 33.6795L30.9846 33.684Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M5.04507 20.04L7.15707 21.4185C7.15707 21.4185 7.93557 22.155 7.81257 22.9335C7.68957 23.712 7.82607 27.6825 7.82607 27.6825C7.82607 27.6825 7.50657 29.3205 6.93207 29.3205C6.35757 29.3205 3.84057 28.3995 3.84057 28.3995L1.80957 27.6825",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2975 32.2799L16.8395 31.3454H15.2015L14.609 30.2609L10.679 29.0939L9.65447 28.0304L9.49097 25.2464L10.5755 24.2429L10.514 22.5434L11.2715 22.1954L11.354 21.5414L13.178 18.5024",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5752 24.2429L17.1662 20.8244H22.3862L36.2777 29.9984L46.8677 30.4919C46.8677 30.4919 46.9502 30.0164 47.4947 29.7764C48.0407 29.5364 53.9357 27.3809 53.9357 27.3809L68.8097 27.7634L70.1747 28.5554L76.9712 28.6379L78.0632 29.3744L93.2657 29.5934L95.1767 29.9999L110.843 30.3299V28.5014L112.808 28.5554",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M110.842 30.3286V32.1151H113.03",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M114.469 19.7475L114.362 20.8245L113.816 21.5145L113.57 24.7065H109.504L106.939 23.07L97.4405 22.9335L96.8135 23.2065L82.5935 22.9875L76.6445 26.5635L76.9715 28.6365",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5326 25.4445C97.5231 25.254 95.4426 24.7875 95.4426 24.7875C94.9326 24.564 94.2126 25.083 93.8331 25.947C93.4536 26.811 93.5601 27.693 94.0701 27.9165C94.2786 28.008 94.9311 28.038 95.3946 27.9675C96.2076 27.8445 97.7001 27.7365 98.6016 27.573C99.2211 27.4605 101.017 27.204 101.017 26.5905C101.017 25.8675 99.5421 25.635 98.5326 25.4445V25.4445Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M96.05 33.8595C95.0405 33.669 92.96 33.2025 92.96 33.2025C92.45 32.979 91.73 33.498 91.3505 34.362C90.971 35.226 91.0775 36.108 91.5875 36.3315C91.796 36.423 92.4485 36.453 92.912 36.3825C93.725 36.2595 95.2175 36.1515 96.119 35.988C96.7385 35.8755 98.534 35.619 98.534 35.0055C98.534 34.2825 97.0595 34.05 96.05 33.8595V33.8595Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1755 23.181C95.1755 23.181 92.72 23.034 91.532 25.512C90.4955 27.6765 91.94 29.5725 93.2645 29.592",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4061 29.523C88.2771 29.394 85.9507 28.2825 85.5412 27.627C85.1317 26.9715 85.1586 25.416 87.0966 24.543C89.0346 23.67 90.8346 23.1135 90.8346 23.1135",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6967 38.025C89.3722 38.0055 87.9263 36.1095 88.9643 33.945C90.1508 31.467 92.6077 31.614 92.6077 31.614L88.2682 31.548C88.2682 31.548 86.4683 32.1045 84.5303 32.9775C82.5923 33.8505 82.5652 35.406 82.9747 36.0615C83.3842 36.717 85.7107 37.8285 85.8397 37.9575L90.6983 38.028L90.6967 38.025Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6077 31.614H96.4312L99.0247 32.5125L112.079 32.9775",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6963 38.0251L104.55 38.6326",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1402 27.4861C20.0962 27.4861 20.8712 26.476 20.8712 25.2301C20.8712 23.9841 20.0962 22.9741 19.1402 22.9741C18.1842 22.9741 17.4092 23.9841 17.4092 25.2301C17.4092 26.476 18.1842 27.4861 19.1402 27.4861Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7969 24.5685H27.8919",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7969 25.8901H27.6279L31.8444 31.1206H33.2364L33.7269 29.9986H36.2784",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8679 30.4935L49.2424 31.9395L84.3274 31.614L88.2679 31.5465",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0664 13.107L38.7624 12.78H39.6219L42.1599 14.7045L43.5114 16.464L41.6289 17.4465L38.0664 13.107Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M105.533 14.541L105.902 14.1315H106.516L108.767 15.6465L110.528 17.4465L109.054 18.204L105.533 14.541Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScattershot);
export default __webpack_public_path__ + "static/media/Scattershot.11d95b9791dd739979337072fd336768.svg";
export { ForwardRef as ReactComponent };